export default "__VITE_ASSET__J3tBqL39__"